import * as React from "react"
import { Link } from "gatsby"
import parse from 'html-react-parser';
import Moment from 'moment';

import IconArrowShortOrange from "../components/icons/IconArrowShortOrange"

const BlogSingleHero = ({ title, date, read }) => {

    var title_nop = title.replace("<p>", "")
    var title_clean = title_nop.replace("</p>", "")

    const formatDate = Moment(date).format('DD.MM.YYYY')

    return (
        <section className="container mx-auto lg:px-24 pt-24 lg:pt-40">
           <Link to={'/ratgeber'} title="Zur Übersicht" className="flex text-lg text-rekord-orange font-semibold no-underline mb-8 items-center">
              <span className="text-3xl mr-1">←</span>
              <span>zur Übersicht</span>
           </Link>
            <div className="flex justify-between pb-6 font-light uppercase">
                <div>
                    {formatDate}
                </div>
                <div>
                    Lesezeit: Ca. {read} Min.
                </div>
            </div>
            <h1 className="text-3xl lg:text-5xl max-w-4xl">{parse(title_clean)}</h1>
        </section>
    )
}

export default BlogSingleHero
